import React from 'react';
import { Stack, Typography } from '@mui/material';
import { formatCurrency } from 'utils';
import { useFormContext, useWatch } from 'react-hook-form';
import { CurrencyInputField } from 'components/form';
import { EquipmentFormValue } from '../../../../types';
import { FieldsContainer } from '../../../components/FieldsContainer';

export const Pricing = () => {
  const { control, getValues, setValue } = useFormContext<EquipmentFormValue>();
  const customerPrice = useWatch({ control, name: 'calcPricing.customer.equipment' });

  const calcTotals = () => {
    const {
      calcPricing: { customer, wholesale, retail },
      commonInfo: { retailPrice, saleCost },
    } = getValues();

    setValue('calcPricing.retail.total', retailPrice + retail.attachments);
    setValue('calcPricing.wholesale.total', saleCost + wholesale.attachments);
    setValue('calcPricing.customer.equipment', retailPrice);
    setValue('calcPricing.customer.total', customer.attachments + retailPrice);
  };

  return (
    <Stack gap="1rem">
      <Typography variant="subtitle2" component="span">
        Pricing
      </Typography>

      <FieldsContainer columns={5}>
        <CurrencyInputField
          control={control}
          label="Wholesale Cost"
          name="commonInfo.saleCost"
          textFieldProps={{ variant: 'outlined' }}
          customOnChange={(nextValue, name) => {
            setValue(name, nextValue);
            calcTotals();
          }}
        />

        <CurrencyInputField
          control={control}
          label="Total Retail Price"
          name="commonInfo.retailPrice"
          textFieldProps={{ variant: 'outlined' }}
          customOnChange={(nextValue, name) => {
            setValue(name, nextValue);
            calcTotals();
          }}
        />
      </FieldsContainer>

      <Typography variant="subtitle2" component="span">
        Customer Price: {formatCurrency(customerPrice, true)}
      </Typography>
    </Stack>
  );
};
